import axios from 'axios';
import { useMutation } from 'react-query';

import getBaseApi from '@luna-protocol/core/src/utils/getBaseApi';
import { LoginResponse } from '@luna-protocol/core/src/types';
import { getUserTypeFromToken } from '@luna-protocol/core/src/utils/getCustomerIdFromToken';
import { getDealerIdFromToken } from '@luna-protocol/core/src/utils/getDealerIdFromToken';
import { getServiceProviderIdFromToken } from '@luna-protocol/core/src/utils/getServiceProviderIdFromToken';

export interface MFAAuthRequest {
  id_token?: string | null;
  token?: string | null;
}

export const postLoginMFA = async (authToken: MFAAuthRequest) => {
  const jwtToken = authToken.id_token ?? authToken.token;

  const resp = await axios.post(`${getBaseApi()}/dealer/login/jwt`, null, {
    headers: { 'Content-Type': 'application/json', 'MFA-JWT': jwtToken },
  });

  if (resp.status !== 200) {
    throw new Error('Login failed');
  }

  // store token in local storage
  localStorage.setItem('user_token', resp.data.token);

  const userType = getUserTypeFromToken(resp.data.token);
  if (userType === 'dealer') {
    localStorage.setItem('entity_id', getDealerIdFromToken(resp.data.token));
  } else if (userType === 'service_provider') {
    localStorage.setItem('entity_id', getServiceProviderIdFromToken(resp.data.token));
  }
  localStorage.setItem('dealer_id', getDealerIdFromToken(resp.data.token));
  return resp.data as LoginResponse;
};

const usePostLoginMFA = () => {
  const mutation = useMutation(postLoginMFA);

  return {
    login: mutation.mutate,
    ...mutation,
  };
};

export { usePostLoginMFA };
